import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { TipoSolicitud } from '@/@core/utils/enums/inventario'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosInventario, { RESOURCE_INVENTARIO } from '@/auth/permissions/modules/inventario'

const { configuracion, informes, mantenimiento, transacciones } = permisosInventario

export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/inventario-consumo/mantenimiento/inventarios',
        name: namesMantenimiento.ROUTE_INVENTARIOS,
        component: () => import('@pages/inventarioMateriales/mantenimiento/CrearInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.crear_tipo_bodega',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.inventarios,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.crear_tipo_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/mantenimiento/bodegas',
        name: namesMantenimiento.ROUTE_BODEGA,
        component: () => import('@pages/inventarioMateriales/mantenimiento/CrearBodega.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.crear_bodega',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.bodega,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.crear_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/mantenimiento/items',
        name: namesMantenimiento.ROUTE_GESTION_ITEMS,
        component: () => import('@pages/inventarioMateriales/mantenimiento/GestionItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.gestion_item',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.gestionItems,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.gestion_item'
            ),
        },
    },
    {
        path: '/inventario-consumo/mantenimiento/categoria-item',
        name: namesMantenimiento.ROUTE_CATEGORIA_BIEN,
        component: () => import('@pages/inventarioMateriales/mantenimiento/CrearCategoria.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.crear_categoria',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.categoriaBien,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.crear_categoria'
            ),
        },
    },
    {
        path: '/inventario-consumo/mantenimiento/linea-item',
        name: namesMantenimiento.ROUTE_LINEAS_BIEN,
        component: () => import('@pages/inventarioMateriales/mantenimiento/CrearLinea.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.crear_linea',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.lineasBien,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.crear_linea'
            ),
        },
    },
    {
        path: '/inventario-consumo/mantenimiento/marcas',
        name: namesMantenimiento.ROUTE_MARCAS,
        component: () => import('@pages/inventarioMateriales/mantenimiento/CrearMarca.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.crear_marca',
            resource: RESOURCE_INVENTARIO,
            action: mantenimiento.marcas,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.mantenimiento',
                'inventario.subopciones.crear_marca'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACIÓN
     */
    {
        path: '/inventario-consumo/configuracion/destinatarios',
        name: namesConfiguracion.ROUTE_DESTINATARIOS,
        component: () => import('@pages/inventarioMateriales/configuracion/Destinatarios.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.destinatarios',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.destinatarios,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.destinatarios'
            ),
        },
    },
    {
        path: '/inventario-consumo/configuracion/jefe-bodega',
        name: namesConfiguracion.ROUTE_JEFE_BODEGA,
        component: () => import('@pages/inventarioMateriales/configuracion/AsignarJefeBodega.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.asignar_jefe_bodega',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.jefeBodega,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.asignar_jefe_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/configuracion/niveles-aprobacion-orden-pedido',
        name: namesConfiguracion.ROUTE_NIVEL_APROBACION_ORDEN_PEDIDO,
        component: () => import('@/views/pages/inventarioMateriales/configuracion/PermisosNivelAprobacionOrdenP.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.permisos_niveles_aprobacion_orden_pedido',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.nivelAprobacionOrdenPedido,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.permisos_niveles_aprobacion_orden_pedido'
            ),
        },
    },
    {
        path: '/inventario-consumo/configuracion/permisos-bodega',
        name: namesConfiguracion.ROUTE_PERMISOS_BODEGA,
        component: () => import('@pages/inventarioMateriales/configuracion/PermisosBodega.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.permisos_bodega',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.permisosBodega,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.permisos_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/configuracion/politica-item/:id_politica?',
        name: namesConfiguracion.ROUTE_POLITICA_ITEM,
        component: () => import('@pages/inventarioMateriales/configuracion/PoliticaItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.politica_items',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.politicaItem,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.politica_items'
            ),
        },
    },
    {
        path: '/inventario-consumo/configuracion/stock-minimo',
        name: namesConfiguracion.ROUTE_STOCK_MINIMO,
        component: () => import('@pages/inventarioMateriales/configuracion/ConfigStockMinimo.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.stock_minimo',
            resource: RESOURCE_INVENTARIO,
            action: configuracion.stockMinimo,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.configuracion',
                'inventario.subopciones.stock_minimo'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/inventario-consumo/transacciones/ingreso-bodega',
        name: namesTransacciones.ROUTE_INGRESO_BODEGA,
        component: () => import('@pages/inventarioMateriales/transacciones/IngresoBodega.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.ingreso_bodega',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.ingresoBodega,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.ingreso_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/egreso-bodega',
        name: namesTransacciones.ROUTE_EGRESO_BODEGA,
        component: () => import('@pages/inventarioMateriales/transacciones/EgresoBodega.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.egreso_bodega',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.egresoBodega,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.egreso_bodega'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/confirmacion-transferencia',
        name: namesTransacciones.ROUTE_CONFIRMACION_TRANSFERENCIA,
        component: () => import('@pages/inventarioMateriales/transacciones/ConfirmacionTransferencia.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.confirmacion_transferencia',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.confirmacionTransferencia,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.confirmacion_transferencia'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/gestion-orden-pedido',
        name: namesTransacciones.ROUTE_GESTION_ORDEN_PEDIDO,
        component: () => import('@pages/inventarioMateriales/transacciones/GestionOrdenPedido.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.gestion_pedido',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.gestionOrdenPedido,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.gestion_pedido'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/orden-pedido/:num_pedido?',
        name: namesTransacciones.ROUTE_ORDEN_PEDIDO,
        component: () => import('@pages/inventarioMateriales/transacciones/OrdenPedido.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.orden_pedido',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.crearOrdenPedido,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.orden_pedido'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-orden-pedido',
        name: namesTransacciones.ROUTE_APROBACION_ORDEN_PEDIDO,
        component: () => import('@pages/inventarioMateriales/transacciones/AprobacionOrdenPedido.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_pedido',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionOrdenPedido,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_pedido'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitudes-item',
        name: namesTransacciones.ROUTE_GESTION_SOLICITUDES_ITEMS,
        component: () => import('@pages/inventarioMateriales/transacciones/MisSolicitudesItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.mis_solicitudes',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.gestionSolicitudesItems,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.mis_solicitudes'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitud-item/:id_solicitud?',
        name: namesTransacciones.ROUTE_CREAR_SOLICITUD_ITEM,
        component: () => import('@pages/inventarioMateriales/transacciones/SolicitudItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.soli_item',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.crearSolicitudItem,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.soli_item'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitud-marca',
        name: namesTransacciones.ROUTE_CREAR_SOLICITUD_MARCA,
        component: () => import('@pages/inventarioMateriales/transacciones/SolicitudMarca.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.solicitud_marca',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.crearSolicitudMarca,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.solicitud_marca'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-solicitud-item',
        name: namesTransacciones.ROUTE_APROBACION_SOLICITUD_ITEM,
        component: () => import('@pages/inventarioMateriales/transacciones/aprobacionItem/AprobacionSolicitudItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_items',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionSolicitudItem,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_items'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-contable-items',
        name: namesTransacciones.ROUTE_APROBACION_CONTABLE_ITEMS,
        component: () =>
            import('@/views/pages/inventarioMateriales/transacciones/aprobacionItem/AprobacionContableItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_cont_items',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionContableItems,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_cont_items'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-tributaria-items',
        name: namesTransacciones.ROUTE_APROBACION_TRIBUTARIA_ITEMS,
        component: () =>
            import('@/views/pages/inventarioMateriales/transacciones/aprobacionItem/AprobacionTributariaItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_trib_items',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionTributariaItems,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_trib_items'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-marca',
        name: namesTransacciones.ROUTE_APROBACION_MARCA,
        component: () => import('@pages/inventarioMateriales/transacciones/AprobacionMarca.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_marca',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionMarca,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_marca'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/gestion-solicitud-consumo',
        name: namesTransacciones.ROUTE_GESTION_SOLICITUD_CONSUMO,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/GestionSolicitudes.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.gestion_solicitud_consumo',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.gestionSolicitudConsumo,
            tipoSolicitud: TipoSolicitud.CONSUMO,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.gestion_solicitud_consumo'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitud-consumo/:num_solicitud?',
        name: namesTransacciones.ROUTE_SOLICITUD_CONSUMO,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/SolicitudConsumo.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.solicitud_consumo',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.solicitudConsumo,
            tipoSolicitud: TipoSolicitud.CONSUMO,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.solicitud_consumo'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-solicitud-consumo',
        name: namesTransacciones.ROUTE_APROBACION_SOLICITUD_CONSUMO,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/AprobacionSolicitud.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_solicitud_consumo',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionSolicitudConsumo,
            tipoSolicitud: TipoSolicitud.CONSUMO,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_solicitud_consumo'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/gestion-solicitud-devolucion',
        name: namesTransacciones.ROUTE_GESTION_SOLICITUD_DEVOLUCION,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/GestionSolicitudes.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.gestion_solicitud_devolucion',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.gestionSolicitudDevolucion,
            tipoSolicitud: TipoSolicitud.DEVOLUCION,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.gestion_solicitud_devolucion'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitud-devolucion/:num_solicitud?',
        name: namesTransacciones.ROUTE_SOLICITUD_DEVOLUCION,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/SolicitudDevolucion.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.solicitud_devolucion',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.solicitudDevolucion,
            tipoSolicitud: TipoSolicitud.DEVOLUCION,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.solicitud_devolucion'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-solicitud-devolucion',
        name: namesTransacciones.ROUTE_APROBACION_SOLICITUD_DEVOLUCION,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/AprobacionSolicitud.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_solicitud_devolucion',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionSolicitudDevolucion,
            tipoSolicitud: TipoSolicitud.DEVOLUCION,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_solicitud_devolucion'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/gestion-solicitud-transferencia',
        name: namesTransacciones.ROUTE_GESTION_SOLICITUD_TRANSFERENCIA,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/GestionSolicitudes.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.gestion_solicitud_transferencia',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.gestionSolicitudTransferencia,
            tipoSolicitud: TipoSolicitud.TRANSFERENCIA,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.gestion_solicitud_transferencia'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/solicitud-transferencia/:num_solicitud?',
        name: namesTransacciones.ROUTE_SOLICITUD_TRANSFERENCIA,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/SolicitudTransferencia.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.solicitud_transferencia',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.solicitudTransferencia,
            tipoSolicitud: TipoSolicitud.TRANSFERENCIA,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.solicitud_transferencia'
            ),
        },
    },
    {
        path: '/inventario-consumo/transacciones/aprobacion-solicitud-transferencia',
        name: namesTransacciones.ROUTE_APROBACION_SOLICITUD_TRANSFERENCIA,
        component: () => import('@pages/inventarioMateriales/transacciones/solicitudes/AprobacionSolicitud.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.aprobacion_solicitud_transferencia',
            resource: RESOURCE_INVENTARIO,
            action: transacciones.aprobacionSolicitudTransferencia,
            tipoSolicitud: TipoSolicitud.TRANSFERENCIA,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.transacciones',
                'inventario.subopciones.aprobacion_solicitud_transferencia'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/inventario-consumo/informes/kardex',
        name: namesInformes.ROUTE_KARDEX,
        component: () => import('@/views/pages/inventarioMateriales/informes/ReporteKardex.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.kardex',
            resource: RESOURCE_INVENTARIO,
            action: informes.kardex,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.kardex'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/estado-inventario',
        name: namesInformes.ROUTE_ESTADO_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/EstadoInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.stock_inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.estadoInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.stock_inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/movimiento-inventario',
        name: namesInformes.ROUTE_MOVIMIENTO_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/MovimientoInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.movimiento_inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.movimientoInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.movimiento_inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/stock-minimo',
        name: namesInformes.ROUTE_STOCK_MINIMO,
        component: () => import('@pages/inventarioMateriales/informes/StockMinimo.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.stock_minimo',
            resource: RESOURCE_INVENTARIO,
            action: informes.stockMinimo,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.stock_minimo'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/resumen-inventario',
        name: namesInformes.ROUTE_RESUMEN_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/ResumenInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.resumen_inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.resumenInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.resumen_inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/nota-ingreso-egreso',
        name: namesInformes.ROUTE_NOTA_INGRESO_EGRESO,
        component: () => import('@pages/inventarioMateriales/informes/NotaIngresoEgreso.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.nota-ingreso-egreso',
            resource: RESOURCE_INVENTARIO,
            action: informes.notaIngresoEgreso,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.nota-ingreso-egreso'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/informe-reposicion',
        name: namesInformes.ROUTE_INFORME_REPOSICION,
        component: () => import('@pages/inventarioMateriales/informes/InformeReposicion.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.informe-reposicion',
            resource: RESOURCE_INVENTARIO,
            action: informes.informeReposicion,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.informe-reposicion'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/toma-inventario',
        name: namesInformes.ROUTE_TOMA_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/TomaInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.toma-inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.tomaInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.toma-inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/rotacion-inventario',
        name: namesInformes.ROUTE_ROTACION_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/RotacionInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.rotacion-inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.rotacionInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.rotacion-inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/movimiento-inventario-general',
        name: namesInformes.ROUTE_MOVIMIENTO_INVENTARIO_GENERAL,
        component: () => import('@pages/inventarioMateriales/informes/MovimientoInventarioGeneral.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.movimiento-inventario-general',
            resource: RESOURCE_INVENTARIO,
            action: informes.movimientoInventarioGeneral,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.movimiento-inventario-general'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/movimiento-transferencias-automaticas',
        name: namesInformes.ROUTE_MOVIMIENTO_TRANSFERENCIAS_AUTOMATICAS,
        component: () => import('@pages/inventarioMateriales/informes/MovimientoTransfAutomaticas.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.movimiento-transferencias-automaticas',
            resource: RESOURCE_INVENTARIO,
            action: informes.movimientoTransferenciasAutomaticas,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.movimiento-transferencias-automaticas'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/rotacion-antiguedad-inventario',
        name: namesInformes.ROUTE_ROTACION_ANTIGUEDAD_INVENTARIO,
        component: () => import('@pages/inventarioMateriales/informes/RotacionAntiguedadInventario.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.rotacion-antiguedad-inventario',
            resource: RESOURCE_INVENTARIO,
            action: informes.rotacionAntiguedadInventario,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.rotacion-antiguedad-inventario'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/estado-inventario-rotacion',
        name: namesInformes.ROUTE_ESTADO_INVENTARIO_ROTACION,
        component: () => import('@pages/inventarioMateriales/informes/EstadoInventarioRotacion.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.estado-inventario-rotacion',
            resource: RESOURCE_INVENTARIO,
            action: informes.estadoInventarioRotacion,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.estado-inventario-rotacion'
            ),
        },
    },
    {
        path: '/inventario-consumo/informes/politicas-item',
        name: namesInformes.ROUTE_POLITICAS_ITEM,
        component: () => import('@pages/inventarioMateriales/informes/PoliticasItem.vue'),
        meta: {
            title: 'i18n:inventario.subopciones.politicas_item',
            resource: RESOURCE_INVENTARIO,
            action: informes.politicasItem,
            breadcrumb: buildBreadcrumb(
                'a:inventario.menu_title',
                'a:global.menu.informes',
                'inventario.subopciones.politicas_item'
            ),
        },
    },
] as RouteConfig[]
